module.exports = __webpack_public_path__ + "static/img/mumi-3.e06ecb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/mumi-3.jpg
// module id = otsL
// module chunks = 1